/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type StationChainStatus = typeof StationChainStatus[keyof typeof StationChainStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StationChainStatus = {
  Active: 'Active',
  Draft: 'Draft',
  Archived: 'Archived',
} as const;
